import React, { Component } from "react";
import ReactDisqusComments from "react-disqus-comments";
import config from "../../../../data/SiteConfig";

class Disqus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toasts: []
    };
    this.notifyAboutComment = this.notifyAboutComment.bind(this);
    this.onSnackbarDismiss = this.onSnackbarDismiss.bind(this);
  }

  componentDidMount() {
    const { postNode } = this.props;
    const url = config.siteUrl + config.pathPrefix + postNode.slug;

    const disqus_config = function () {
      this.page.url = url;  // Replace PAGE_URL with your page's canonical URL variable
      this.page.identifier = url; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
    };

    (function(d) { // DON'T EDIT BELOW THIS LINE
    const s = d.createElement('script');
    s.src = 'https://singletrackhack.disqus.com/embed.js';
    s.setAttribute('data-timestamp', +new Date());
    (d.head || d.body).appendChild(s);
    })(document)
  }

  onSnackbarDismiss() {
    const [, ...toasts] = this.state.toasts;
    this.setState({ toasts });
  }

  notifyAboutComment() {
    const toasts = this.state.toasts.slice();
    toasts.push({ text: "New comment available!" });
    this.setState({ toasts });
  }

  render() {
    return (
      <div>
        <div id="disqus_thread" />
      </div>
    )
  }
}

export default Disqus;



// WEBPACK FOOTER //
// ./src/components/Accessories/Disqus/Disqus.jsx